module.exports = __webpack_public_path__ + "img/reload-white.74a11a7b.svg";